import codes from './tel-codes.json';

const SELECT_SELECTOR = '.js-tel-code-select';
const LIST_SELECTOR = '.js-list';
const FAVORITE_CODES = ['DE', 'CH'];

const favoriteCountries = codes.filter((country) => FAVORITE_CODES.includes(country.code));
const restCountries = codes.filter((country) => !FAVORITE_CODES.includes(country.code));

const createOption = (country, locale) => {
	const label = country[locale] || country['de-DE'];
	return `<button class="select__item js-option" data-value="${country.telCode}">${label} ${country.telCode}</button>`;
};

export const initTelCodeSelect = () => {
	document.querySelectorAll(SELECT_SELECTOR).forEach((containerEl) => {
		const listEl = containerEl.querySelector(LIST_SELECTOR);
		if (!listEl) return;

		const locale = containerEl.dataset.locale;
		const optionsHTML = [
			...favoriteCountries.map((country) => createOption(country, locale)),
			'<div class="list-separator"></div>',
			...restCountries.map((country) => createOption(country, locale)),
		].join('');

		listEl.innerHTML = optionsHTML;
	});
};
